import { render, staticRenderFns } from "./AdvisoryPackageIntro3.vue?vue&type=template&id=6bbaf8ae&scoped=true"
import script from "./AdvisoryPackageIntro3.vue?vue&type=script&lang=js"
export * from "./AdvisoryPackageIntro3.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryPackageIntro3.vue?vue&type=style&index=0&id=6bbaf8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbaf8ae",
  null
  
)

export default component.exports